import {
  PopoverStyled, PopoverStyledButton, PopoverStyledPanel,
  Button,
} from '@components/common';
import { ApiHeaderInfoOk } from '@type/v1-api-types';
import { BurgerMenuLinks } from '@components/layout/Header/MainNavbar/links';
import { ProfileAvatar } from './ProfileAvatar';

interface MobileAccountMenuProps {
  headerInfo?: ApiHeaderInfoOk;
  className?: string;
}

/**
 * @description Mobile-only account button. Renders an always-visible account avatar/icon that
 * opens the same dropdown as the desktop ProfileSection (edit cv / company profile / wallet /
 * logout … via BurgerMenuLinks + the language switcher).
 *
 * Unlike ProfileSection's trigger (ProfileInNavbar), the avatar here is visible at every width
 * below `lg`, so the control never disappears in the md range — it is the account entry point
 * for all mobile/tablet pages.
 */
export const MobileAccountMenu = ({ headerInfo, className }: MobileAccountMenuProps) => (
  <PopoverStyled className={className}>
    {/* temporary fix for Next15 upgrade; will be fixed after headless ui upgrade */}
    { }
    {({ close }) => (
      <>
        <PopoverStyledButton
          as={Button}
          styling="none"
          aria-label="account.label.myaccount"
          className="flex cursor-pointer items-center p-1 outline-none"
        >
          <ProfileAvatar headerInfo={headerInfo} />
        </PopoverStyledButton>

        <PopoverStyledPanel
          position="right"
          className="top-full mt-1 max-h-[75vh] min-w-72 overflow-y-auto"
        >
          <div className="bg-surface-50">
            <BurgerMenuLinks className="py-4" closePopoverDesktop={close} />
          </div>
        </PopoverStyledPanel>
      </>
    )}
  </PopoverStyled>
);
